// import {common} from '@/assets/js/common.js'
export const base = {
  // 首页初始化
  HOME_INIT: 'home/init',
  // 获取配置
  GET_CONFIG: 'other/util/getConfig',
  // --------------------------  Better课程 start  --------------------------
  // 课程列表
  COURSE_LIST: 'course/getList',
  // 课程详情
  COURSE_INFO: 'course/info',
  // 训练营详情
  TRAINING_CAMP: 'training_camp/info',
  // 评分
  SET_MARK: 'section/setMark',
  // 用户课程
  USER_COURSE: 'course/getUserCourses',
  // 书签
  BOOK_MARK: 'section/getBookMarks',
  // 章节列表
  SECTION_LIST: 'section/getList',
  // 章节详情
  SECTION_INFO: 'section/info',
  // 章节播放地址
  SECTION_PLAY: 'course/section/play',
  // 新增、编辑日志
  EDIT_LOG: 'section/log/edit',
  // 商品详情
  GOODS_INFO: 'goods/info',
  // 获取赠送码
  GIFT_KEY: 'other/share/getGiftKey',
  // 赠送课程
  BY_GIFT: 'pay/activation/byGiftKey',
  // --------------------------  Better课程 end  --------------------------
  // -------------------------- 用户 start --------------------------------
  // 获取用户信息
  USER_INFO: 'user/info',
  // 编辑用户信息
  EDIT_USER: 'user/edit',
  // 检查手机号
  CHECK_MOBILE: 'user/checkMobile',
  // 发送验证码
  SEND_CODE: 'user/sendSMSCode',
  // 绑定手机号
  BIND_MOBILE: 'user/bindMoblie',
  // 用户账户信息
  ACCOUNT_INFO: 'user/getAccountInfo',
  // 交易记录
  TRADE_RECORD: 'user/getTradeRecords',
  // 交易记录详情
  TRADE_RECORD_INFO: 'user/getTradeRecordInfo',
  // 提现记录
  WITH_DRAW: 'finance/withdraw/getList',
  // 提现申请
  WITH_DRAW_APPLY: 'finance/withdraw/apply',
  // 提现详情
  WITH_DRAW_INFO: 'finance/withdraw/info',
  // 税金计算
  WITH_DRAW_TAX: 'finance/withdraw/getTax',
  // 实名认证
  REALNAME_AUTH: 'user/realnameAuth',
  // 实名认证信息
  REALNAME_AUTH_INFO: 'user/getRealnameAuthInfo',
  // 获取意见反馈
  FEED_BACK: 'other/feedback/getList',
  // 意见反馈详情
  FEED_BACK_INFO: 'other/feedback/info',
  // 新增意见反馈
  ADD_FEED_BACK: 'other/feedback/add',
  // 删除意见反馈
  DEL_FEED_BACK: 'other/feedback/delete',
  // 获取通知消息列表
  NOTICE_LIST: 'other/notice/getList',
  // 设置通知消息已读
  NOTICE_READ: 'other/notice/setRead',
  // 获取通知消息未读的数量
  NOTICE_UNREAD_COUNT: 'other/notice/getUnreadCount',
  // 删除通知消息
  NOTICE_DEL: 'other/notice/delete',
  // 日历列表
  CALENDAR_LIST: 'user/calendar/getList',
  // 检查今日打卡状态
  CHECK_IN_STATUS: 'user/checkIn/status',
  // 签到打卡
  CHECK_IN: 'user/checkIn/action',
  // 获取用户日记列表
  DIARY_LIST: 'user/diary/getList',
  // 获取用户日历详情
  DIARY_INFO: 'user/diary/info',
  // 新增、编辑日记
  DIARY_EDIT: 'user/diary/store',
  // 删除日记
  DIARY_DEL: 'user/diary/delete',
  // -------------------------- 用户 end ----------------------------------
  // -------------------------  考试 start --------------------------------
  // 获取用户考试列表
  EXAM_LIST: 'exam/getUserExamList',
  // 获取用户试卷信息
  EXAM_INFO: 'exam/getUserExamInfo',
  // 开始考试
  EXAM_BEGIN: 'exam/startExam',
  // 获取考试试题
  EXAM_QUESTION: 'exam/getQuestion',
  // 提交试卷
  EXAM_SUBMIT: 'exam/submitAnswers',
  // 查看结果
  EXAM_RESULT: 'exam/getAnswerResult',
  // 查看错题
  EXAM_WRONG: 'exam/getWrongQuestions',
  // -------------------------- 考试 end ----------------------------------
  // --------------------------  Read青音共读会 start  ---------------------
  // 初始化
  INIT: 'common/init',
  // 获取微信开发列表
  getJSLIST: 'other/util/base',
  // 获取分享设置
  GET_SHARE: 'other/share/getConfig',
  // 激活码激活课程
  ACTIVE_CODE: 'pay/activation/byCode',
  // 渠道领取
  ACTIVE_BY_CHANNELKEY: 'pay/activation/byChannelKey',
  // 购买成功
  PAY_SUCCESS: 'pay/success',
  // 获取二维码
  GET_QRCODE: 'common/g_qrcode',
  // 二维码识别次数
  S_QRCOUNT: 'other/qrcode/identifyInc',
  // 初始化
  INIT_CONFIG: 'init/config',
  // 获取专栏列表
  PACKAGE_LIST: 'read/package/getList',
  // 专栏详情
  PACKAGE_INFO: 'read/package/info',
  // 专栏下的图书列表
  BOOK_LIST: 'read/book/getList',
  // 图书详情
  BOOK_INFO: 'read/book/info',
  // 图书音频播放
  BOOK_PLAY: 'read/book/play',
  // 直播列表1
  LIVE_LIST: 'read/live/getList',
  // 直播邀请码
  LIVE_CODE: 'read/live/getInviteCode',
  // 点赞榜列表
  RANK_LIST: 'read/ranking/getList',
  // 点赞榜基本信息
  RANK_INFO: 'read/ranking/info',
  // 空间信息
  ZONE_INFO: 'read/zone/info',
  // 获取我的空间列表
  MOMENT_LIST: 'read/moments/getList',
  // 获取moment详情
  MOMENT_INFO: 'read/moments/info',
  // 设置动态为公开/私密
  SET_PUBLIC: 'read/moments/setPublic',
  // 删除用户动态
  DEL_MOMENT: 'read/moments/delete',
  // 发布用户动态
  SEND_MOMENT: 'read/moments/send',
  // 点赞用户状态
  SET_LIKE: 'read/moments/setLike',
  // 举报
  REPORT: 'read/report',
  // -----------------------  Read 青音共读会 end  -------------------
  // -----------------------  Radio 青音夜谈 start  ------------------
  RADIO_INFO: 'radio/info',
  // 夜谈章节时间范围
  RADIO_SECTION_RANGE: 'section/getRange',
  // -----------------------  Radio 青音夜谈 end  ------------------
  // -----------------------  优惠券  ------------------------------
  COUPON_LIST: 'coupon/getCDList',
  // 优惠券详情
  COUPON_INFO: 'coupon/getCDInfo',
  // 优惠券核销
  COUPON_WRITEOFF: 'coupon/writeoff'
}



// WEBPACK FOOTER //
// ./src/api/base.js